import React from 'react';
import { Modal, Button, Row } from 'react-bootstrap';
import "../../../assets/scss/geoShapeModal.scss";
// import { ButtonGroupToggle } from '../widgets';
import ImportShapeGroup from './ImportShapeGroup';
import ImportShapeList from './ImportShapeList';

export default function GeoShapeModal({ tabs, isNewRegion, discardRegions, saveRegions, newRegions, setSelectedViewType, selectedViewType, isIgnore, isOverwrite, handleIgnore, handleOverride }) {
    let availableShapes = [], isavailableShapes = false;
    const shapes = newRegions.length < 1 ? [] : newRegions.map((reg) => reg.shapes);

    for (const shape of shapes) {
        availableShapes.push(...shape);
    }
    isavailableShapes = availableShapes.length < 1 ? false : true;

    return (
        <>
            <Modal show={isNewRegion} backdrop="static" onHide={discardRegions} className="geo_shape_modal" >
                <Modal.Header closeButton  >
                    <Modal.Title style={{ fontSize: '1.25rem' }}>
                        <i className="fa fa-upload"></i> Import
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-0">
                    <div className='row'>
                        <div className='col-md-6 mt-3 mb-2'>
                            {/* <ButtonGroupToggle
                                options={tabs}
                                value={selectedViewType} onSelect={(type) => setSelectedViewType(type)}
                                className="btn-group-toggle" /> */}
                        </div>
                        <div className="col-md-6 d-flex justify-content-end form-check mt-3 mb-1">
                            <div>
                                <input className="form-check-input" type="checkbox" value="" checked={isOverwrite} id="overwrite" onChange={(e) => handleOverride(e.target.checked)} />
                                <label className="form-check-label" htmlFor="overwrite" style={{ cursor: "pointer" }}>
                                    Overwrite
                                </label>
                            </div>
                            <div style={{ marginLeft: "35px" }}>
                                <input className="form-check-input" type="checkbox" value="" checked={isIgnore} id="ignoreDuplicate" onChange={(e) => handleIgnore(e.target.checked)} />
                                <label className="form-check-label" htmlFor="ignoreDuplicate" style={{ cursor: "pointer" }}>
                                    Ignore Duplicate
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='modal-body-content'>
                        <Row className={`m-0 ${selectedViewType === 2 ? "show" : "hide"}`}>
                            <ImportShapeGroup isavailableShapes={isavailableShapes} newRegions={newRegions} />
                        </Row>
                        <Row className={`m-0 ${selectedViewType === 1 ? "show" : "hide"}`}>
                            <ImportShapeList isavailableShapes={isavailableShapes} newRegions={newRegions} />
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="btn btn-danger btn-sm" onClick={discardRegions} ><i className="fa fa-times-circle"></i> Discard</Button>
                    <Button variant="btn btn-primary btn-sm" disabled={!isavailableShapes} onClick={saveRegions}><i className="fa fa-floppy-o"></i> Import & Save</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
